import { render, staticRenderFns } from "./bgaChangeHistory.vue?vue&type=template&id=ccdf2268&scoped=true"
import script from "./bgaChangeHistory.vue?vue&type=script&lang=js"
export * from "./bgaChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./bgaChangeHistory.vue?vue&type=style&index=0&id=ccdf2268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdf2268",
  null
  
)

export default component.exports